import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { reset } from 'redux-form';
import { MODAL_TYPE_CLIENT_EXAMINATION_ALERT, showModal, } from '../../../../actions/ModalActions';
import { solutionPickup } from '../../../../actions/SearchSolutionActions';
import { propArrayOf, propBool, propFunc, propOneOfType, propShape, propStr, PropTypesAuthToken, } from '../../../../helpers/custom-prop-types';
import IsLoadingHoc from '../../../Layout/Loading/IsLoadingHoc';
import ExaminationAlertAndHeadCardFullModalByReducer from '../../../Ui/Modal/ExaminationAlertAndHeadCardFullModalByReducer';
import SendPickupCompleteModal from '../Modal/SendPickupCompleteModal';
import SearchItems from './SearchItems';
const SearchBody = (props) => {
    const { auth, isMoreLoading, profile, resetPickup, runMoreQuery, searchSolution, sendPickup, showExaminationModal, showSendPickupCompleteModal, viewItems, } = props;
    return (_jsxs(_Fragment, { children: [_jsx(SearchItems, { auth: auth, isMoreLoading: isMoreLoading, profile: profile, resetPickup: resetPickup, runMoreQuery: runMoreQuery, searchSolution: searchSolution, sendPickup: sendPickup, showExaminationModal: showExaminationModal, showSendPickupCompleteModal: showSendPickupCompleteModal, viewItems: viewItems }), _jsx(ExaminationAlertAndHeadCardFullModalByReducer, {}), _jsx(SendPickupCompleteModal, {})] }));
};
SearchBody.propTypes = {
    auth: PropTypesAuthToken.isRequired,
    isMoreLoading: propBool().isRequired,
    profile: propShape().isRequired,
    resetPickup: propFunc().isRequired,
    runMoreQuery: propFunc().isRequired,
    searchSolution: propShape().isRequired,
    sendPickup: propFunc().isRequired,
    showExaminationModal: propFunc().isRequired,
    showSendPickupCompleteModal: propFunc().isRequired,
    viewItems: propArrayOf(propOneOfType([propShape(), propStr()])).isRequired,
};
const mapDispatchToProps = (dispatch) => ({
    resetPickup: () => dispatch(reset('ProffitMartRecommended')),
    sendPickup: (values) => new Promise((resolve, reject) => {
        const action = solutionPickup(values, {
            reject,
            resolve: ({ payload }) => resolve(payload),
        });
        dispatch(action);
    }),
    showExaminationModal: () => dispatch(showModal(MODAL_TYPE_CLIENT_EXAMINATION_ALERT)),
});
const enhance = compose(IsLoadingHoc, connect(null, mapDispatchToProps));
export default enhance(SearchBody);
